import axios from 'axios'

export const login = async ({ email, password }) => {
  return axios.post('/api/login', {
    email,
    password,
  })
}

export const forgotPassword = async ({ email }) => {
  return axios
    .post('/api/forgotPassword', {
      email,
    })
    .then((response) => response.data)
}

export const resetPassword = async ({ password, token }) => {
  return axios
    .post('/api/resetPassword', {
      password,
      token,
    })
    .then((response) => response.data)
}

export const logout = async () => {
  return axios.post('/api/logout')
}

export const getConnectedUser = async () => {
  return axios.get('/api/user/me').then((response) => response.data)
}

export const createUser = async (user) => {
  return axios.post('/api/users', user).then((response) => response.data)
}

export const updateUser = async (user) => {
  return axios.put(`/api/user/${user.id}`, user).then((response) => response.data)
}

export const getUsers = async () => {
  return axios.get('/api/users')
}

export const getUserById = async (id) => {
  return axios.get(`/api/user/${id}`).then((response) => response.data)
}

export const getUserByPasswordToken = async (passwordToken) => {
  return axios.get(`/api/user/token/${passwordToken}`)
}

export const linkAircallAccount = async (userId) => {
  return axios.post(`/api/user/${userId}/link-aircall-account`).then((response) => response.data)
}

export const activate = async (id) => {
  return axios.post(`/api/user/${id}/activate`).then((response) => response.data)
}

export const deactivate = async (id) => {
  return axios.post(`/api/user/${id}/deactivate`).then((response) => response.data)
}

export const getActiveUsers = async () => {
  return axios.get('/api/users/active').then((response) => response.data)
}

export const viewLeadPage = async ({ leadId }) => {
  return axios.post('/api/users/view-lead-page', { leadId }).then((response) => response.data)
}

export const quitLeadPage = async () => {
  return axios.post('/api/users/quit-lead-page').then((response) => response.data)
}

export const unassignLeadFromUser = async () => {
  return axios.post('/api/users/unassign-lead-from-user').then((res) => res.data)
}

export const getWorkingUsers = async () => {
  return axios.get('/api/users/working').then((response) => response.data)
}

export const getUserViewingLead = async (userId) => {
  return axios.get(`/api/user/${userId}/viewing-lead`).then((response) => response.data)
}

export const changePreference = async ({ preferenceKey, preferenceValue }) => {
  return axios.post(`/api/user/preference/${preferenceKey}`, { preferenceValue }).then((response) => response.data)
}

export const getUserTimeline = async ({ userId, search }) => {
  return axios.get(`/api/user/${userId}/timeline`, { params: { search } }).then((response) => response.data)
}

export const uploadUserAvatar = async (file) => {
  const form = new FormData();
  form.append('file', file);

  return await axios.post(`/api/user/avatar`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true,
  }).then((response) => response.data)
}

export default {
  login,
  logout,
  getConnectedUser,
  forgotPassword,
  getConnectedUser,
  createUser,
  getUsers,
  getUserById,
  getUserByPasswordToken,
  linkAircallAccount,
  activate,
  deactivate,
  getActiveUsers,
  viewLeadPage,
  quitLeadPage,
  unassignLeadFromUser,
  getWorkingUsers,
  getUserViewingLead,
  changePreference,
  getUserTimeline,
  uploadUserAvatar,
}
